import { Provider } from '@shopify/app-bridge-react';
import { AppProvider } from '@shopify/polaris';
import Orders from './orders';
import ShowLocation from './locations/Show';
import ChargeCustomer from './customers/Charge';
import Customers from './customers';

import translations from '@shopify/polaris/locales/en.json';

import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import ChargeCustomerForOrder from "./customers/ChargeOrder";
import Index from './dashboard/Index';

const Main = (props) => {
    return (
        <Provider config={props.config}>
            <AppProvider i18n={translations}>
                <Router>
                    <Switch>
                        <Redirect path="/home" to="/dashboard" />
                        <Route path="/dashboard"><Index /></Route>
                        <Route path="/charge/order"><ChargeCustomerForOrder /></Route>
                        <Route path="/charge"><ChargeCustomer /></Route>
                        <Route path="/orders/:customerid"><Orders /></Route>
                        <Route path="/customers"><Customers /></Route>
                        <Route path="/locations/:locationId"><ShowLocation /></Route>
                    </Switch>
                </Router>
            </AppProvider>
        </Provider>

    );
}


export default Main;
